import type { Logger } from '@main/utils/logger';
import { BusEventListener } from '@main/event-listeners/bus-event-listener';
import { LoginPageEventListener } from '@main/event-listeners/login-page-event-listener';

export class EventListenerFacade {
  private static ins: EventListenerFacade;

  private busEventListener!: BusEventListener;
  private loginPageEventListener!: LoginPageEventListener;

  constructor(private logger?: Logger) {
    if (EventListenerFacade.ins) {
      return EventListenerFacade.ins;
    }
    if (!this.logger) this.logger = <never>console;
    this.busEventListener = new BusEventListener(this.logger);
    this.loginPageEventListener = new LoginPageEventListener(this.logger);

    return (EventListenerFacade.ins = this);
  }

  initEventListeners() {
    this.busEventListener.addEventListener();
    this.loginPageEventListener.addEventListener();
  }
}
